import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'policy.view.policy-details.Policy Details',
        defaultMessage: 'Policy Details: {policyNumber}'
    },
    currentTab: {
        id: 'policy.view.policy-details.tab.Current',
        defaultMessage: 'Current'
    },
    changePolicy: {
        id: 'policy.view.policy-details.Change Policy',
        defaultMessage: 'Change Policy'
    },
    renewalTab: {
        id: 'policy.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewing'
    },
    DownloadIDCard: {
        id: 'policy.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card'
    },
    CanNotLoadYourPolicyAtThisTime: {
        id: 'tdic.policy.view.policy-details.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    policyRequestFailed: {
        id: 'tdic.policy.view.policy-details.ERROR',
        defaultMessage: 'ERROR'
    },
    editPolicyProfile: {
        id: 'tdic.policy.view.policy-details.Edit Policy Profile',
        defaultMessage: 'Edit Policy Profile'
    },
    policyEditTooltip: {
        id: 'tdic.policy.view.policy-details.Edit your paperless delivery preference, mailing address, phone number, or email address.',
        defaultMessage: 'Edit your paperless delivery preference, mailing address, phone number, or email address.'
    },
    policyChange: {
        id: 'tdic.policy.view.policy-details.policychange',
        defaultMessage: 'Policy Change'
    }
});
